<template>
	<!-- 弹窗框 -->
	<el-dialog 
		title="分配到现金流量表"
		:visible.sync="isShow"
		width="1200px" 
		top='60px'
		:close-on-click-modal="false"
		:show-close='false'
		append-to-body
		id='flowDialog'
		  >
		<div class='nowMessage'>
			<div class='public_title'>
				当前所选分录信息
			</div>
			<public-table :table='tableData'></public-table>
		</div>
		<div class='itemTable_wrapper'>
			<div class='public_title'>
				请选择需要录入的项目
			</div>
			<public-table :table='tableData1' ref='dataTable' @clickRow='clickRow'></public-table>
		</div>
		<div class='footer'>
			<el-button class='cancel' size='small' @click='isShow=false'>取消</el-button>
			<el-button class='save' size='small' @click = 'handleSaveData'>确定</el-button>
		</div>
	</el-dialog>
</template>

<script>
	import publicTable from '@/components/publicTable'
	import {currencys} from '@/assets/utils/currencyFormat'
	export default{
		props:{
			isFlowDialogShow: {
				type:Boolean,
				default:false
			},
			rowMessage: {
				type:Object,
				default:{}
			}
		},
		components:{
			publicTable
		},
		data(){
			return{
				tableData1: {
					border: true,				// 是否带有纵向边框
					stripe: true,				// 是否带有斑马纹
					loading: false,				// 是否显示加载动画
					hasSelect: true,			// 是否显示多选
					hasOperation: false,			// 是否有操作功能
					hasContextmenu: false,		// 是否有右键功能
					hasShowSummary: false,		// 是否显示合计行
					hasShowPagination: false,	// 是否显示分页
					Maxheight:"400px",
					config: [{
						label: '项目',
						value: 'name',
						show: 'normal'
					},{
						label: '行数',
						value: 'rowNumber',
						width:80,
						show: 'normal'
					},{
						label: '本月累计',
						value: 'periodsNumber',
						show: 'normal',
						width:220,
						formatter: this.formatter
					},{
						label: '本次录入金额',
						value: 'nowInputMoney',
						show: 'normal',
						width:220,
						formatter: this.formatter
					}],
					data: [],
					center: {
						textAlign: 'center',
						padding: '6px 0'
					},
					toggleRowSelection: this.toggleRowSelection,		// 自定义全选方法
					selectable: this.selectable        // 自定义禁用
				},
				tableData: {
					border: true,				// 是否带有纵向边框
					stripe: true,				// 是否带有斑马纹
					loading: false,				// 是否显示加载动画
					hasSelect: false,			// 是否显示多选
					hasOperation: false,			// 是否有操作功能
					hasContextmenu: false,		// 是否有右键功能
					hasShowSummary: false,		// 是否显示合计行
					hasShowPagination: false,	// 是否显示分页
					config: [{
						label: '摘要',
						value: 'summary',
						show: 'normal'
					},{
						label: '科目',
						value: 'subjectName',
						show: 'normal',
						formatter: this.formatter
					},{
						label: '借方金额',
						value: 'debitMoney',
						show: 'normal',
						formatter: this.formatter
					},{
						label: '贷方金额',
						value: 'creditorMoney',
						show: 'normal',
						formatter: this.formatter
					}],
					data: [],
					center: {
						textAlign: 'center',
						padding: '6px 0'
					}
				},
				ids:"",  // 当前所选ID
				selectIds:[],
			}
		},
		created() {

		},
		methods:{
			// 行点击选中
			clickRow(data) {
				if(data.row.style!=1) {
					return 
				}
				if(this.selectIds.indexOf(data.row.id)>=0) {
					this.$refs.dataTable.$refs.table.toggleRowSelection(data.row,false);
				}else {
					this.$refs.dataTable.$refs.table.toggleRowSelection(data.row,true);
				}
			},
			// 保存选择
			handleSaveData() {
				this.$emit('flowIds',this.ids);
				this.isShow = false;
			},
			// 全选
			toggleRowSelection(val) {
				this.tableData1.data.forEach(item=>{   // 重置录入金额
					item.nowInputMoney = ""
				})
				let ids = [];
				if(val.length) {
					val.forEach(item=>{
						ids.push(item.id);
						// if(item.rowNumber == 32) {
						// 	item.nowInputMoney = this.rowMessage.debitMoney || - this.rowMessage.creditorMoney
						// }else {
						item.nowInputMoney = Math.abs(this.rowMessage.debitMoney) || Math.abs(this.rowMessage.creditorMoney)
						//}
					})
				}
				this.selectIds = ids;
				this.ids = ids.toString();
			},
			// 自定义禁用
			selectable(row, index) {
				if(row.style==1) {
					return true;
				}else {
					return false;
				}
			},
			// 当前分录表格格式化
			formatter(row, column, cellValue, index) {
				if(column.property == "subjectName") {
					if(row.subjectVo&&row.subjectVo.code&&row.subjectVo.name) {
						return row.subjectVo.code + " " + row.subjectVo.name;
					}else {
						return row.subjectName;
					}
					
				}else {
					return row[column.property]?currencys(row[column.property]):""
				}
			},
			// 设置默认选中
			checked() {
				this.tableData1.data.forEach(row => {
				  	let fkCashFlowIds = this.rowMessage.fkCashFlowIds?this.rowMessage.fkCashFlowIds.split(','):[];
				    if(fkCashFlowIds.indexOf(row.id) >= 0){
				        this.$refs.dataTable.$refs.table.toggleRowSelection(row,true);
				    }
				  })
			},
			// 获取现金流量表
			getTableData() {
				const that = this;
				that.tableData1.loading = true;
				let yearPeriods = "";
				if(that.rowMessage.yearPeriods) {
					yearPeriods = that.rowMessage.yearPeriods;
				}else {
					yearPeriods = JSON.parse(sessionStorage.getItem('accountInfo')).nowYearPeriod
				}
				let params = {
					yearPeriods
				}
				that.$http.post('reportform/getCashFlowFrom',params).then(res=>{
					that.tableData1.loading = false;
					
		            if(res && res.data.code == 1) {
		             	that.tableData1.data = res.data.data.map((i,index)=>{
		             		i.rowNumber = index + 1;
		             		return i;
		             	});

		             	that.$nextTick(()=>{ 
		             		setTimeout(()=>{
		             			that.checked();
		             		},100)
		             	})
		            }
		         })
			},
		},
		computed:{
			isShow:{
				get(){
					return this.isFlowDialogShow;
				},
				set(val){
					this.$emit('update:isFlowDialogShow', val);
				}
			}
		},
		watch:{
			rowMessage(val) {

			},
			isFlowDialogShow(val){
				if(val) {
					this.tableData.data = [];
					this.tableData.data.push(this.rowMessage);
					this.getTableData();
				}
			}
		}
	}
</script>

<style lang='less'>
	#flowDialog {
		.public_title {
			margin-bottom: 20px;
			color: #333;
			font-weight: 600;
		}
		.itemTable_wrapper {
			margin-top: 40px;
			padding: 20px;
			border: 1px dashed rgba(217,217,217,1);
			background: rgba(251,251,251,0.66);
		}
		.nowMessage {
			
		}
		.footer {
			text-align: center;
			margin-top: 40px;
			.cancel,.save {
				color: #fff;
				width: 122px;
			}
			.cancel {
				background: #9B9B9B;
			}
			.save {
				background: #269D7B;
			}
		}
		.el-dialog__header {
			text-align: center;
			padding: 40px 0 0px 0;
			.el-dialog__title {
				font-size: 30px;
			}
			
		}
		.el-dialog__body {
			padding: 30px;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/dialog/distributionFlowDialog.vue